module.exports = __webpack_public_path__ + "media/images/courseware_completion_status_not_started-66fc822fadde7edd3ad9613b56f47430.svg";